import PropTypes from 'prop-types';
import InputField from '../../../components/InputField';
import styles from './Institution.module.scss';

const ContactForm = ({ formData, onInputChange }) => {
  return (
    <section className={styles.section}>
      <h2 className={styles.sectionTitle}>Contact details</h2>
      <div className={styles.formGrid}>
        <InputField
          label="First name"
          id="firstName"
          name="firstName"
          required
          type="text"
          placeholder="First name"
          value={formData.firstName}
          onChange={e => onInputChange('firstName', e.target.value)}
        />

        <InputField
          label="Last name"
          id="lastName"
          name="lastName"
          required
          type="text"
          placeholder="Last name"
          value={formData.lastName}
          onChange={e => onInputChange('lastName', e.target.value)}
        />

        <InputField
          label="Email"
          id="email"
          name="email"
          required
          type="email"
          placeholder="Email address"
          value={formData.email}
          onChange={e => onInputChange('email', e.target.value)}
        />

        <InputField
          label="Organisation"
          id="organisation"
          name="organisation"
          required
          type="text"
          placeholder="Organisation name"
          value={formData.organisation}
          onChange={e => onInputChange('organisation', e.target.value)}
        />

        <InputField
          label="ABN"
          id="abn"
          name="abn"
          type="text"
          placeholder="12345678901"
          required={false}
          value={formData.abn}
          onChange={e => onInputChange('abn', e.target.value)}
        />

        <InputField
          label="Contact number"
          id="contactNumber"
          name="contactNumber"
          required
          type="tel"
          placeholder="Contact number"
          value={formData.contactNumber}
          onChange={e => onInputChange('contactNumber', e.target.value)}
        />
      </div>
    </section>
  );
};

ContactForm.propTypes = {
  formData: PropTypes.shape({
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    organisation: PropTypes.string.isRequired,
    abn: PropTypes.string.isRequired,
    contactNumber: PropTypes.string.isRequired
  }).isRequired,
  onInputChange: PropTypes.func.isRequired
};

export default ContactForm;
